import { TemplateData, TemplateParams } from '.';

const userCustomAttributesNotification = ({
  defaultPlaceholders,
  messages
}: TemplateParams): TemplateData => ({
  category: 'common',
  email: {
    buttonEnabled: true,
    buttonLink: '{{siteUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        {{description}}
      </p>
      <p>
        {{usersList}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: {{subject}}`
  },
  placeholders: {
    description: {
      label: messages.emailDescription
    },
    subject: {
      label: messages.emailSubject
    },
    usersList: {
      label: messages.emailCustomAttributesUsersList
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeUserCustomAttributesNotification
});

export default userCustomAttributesNotification;
